import React from 'react';
import { useEffect, useState } from 'react';
import { useNavigate, Link } from "react-router-dom";
import $ from 'jquery';
import Modal from "react-modal";
import { withRouter } from '../utils/withRouter';
import { axiosGet, axiosPost } from "../react_axios/Axios"
import { headers, getCartDetailsUrl } from "../utils/constants"
import moment from 'moment';

const Header = (mod) => {
    var guest = false
    const [cartNo, setCartNo] = useState(null)

    const getCartNo = async (userId) => {
        try {

            const mapdata = {
                userID: parseInt(userId),
                OrderID: null,
            }
            // console.log("data----------", mapdata)
            const res = await axiosGet(getCartDetailsUrl, mapdata, headers);
            var noOfCart = []
            if (res?.error == 0) {
                for (var i = 0; i < res.data.orderArr.length; i++) {
                    if (!noOfCart.includes(res.data.orderArr[i].OrderID)) {
                        noOfCart.push(res.data.orderArr[i].OrderID)
                    }
                }
            }
            // console.log(noOfCart)
            setCartNo(noOfCart.length)
            return Promise.resolve(res);
        } catch (err) {
            return Promise.reject(err);
        }
    };
    useEffect(() => {
        setTimeout(() => {
            JSON.parse(sessionStorage.getItem('UserLoginData')) != null && JSON.parse(sessionStorage.getItem('UserLoginData')).UserID != null && getCartNo(JSON.parse(sessionStorage.getItem('UserLoginData')).UserID);
        }, 100);

    }, []);


    if ((sessionStorage.getItem('UserLoginData')) == null) {
        guest = true
    }
    var finalAccesslist = []
    if (JSON.parse(sessionStorage.getItem('UserLoginData')) != null && JSON.parse(sessionStorage.getItem('UserLoginData')) != '') {
        var name = (JSON.parse(sessionStorage.getItem('UserLoginData'))).UserName
        var companyName = (JSON.parse(sessionStorage.getItem('UserLoginData'))).CompanyName
        var initial = name[0]
    }
    if (sessionStorage.getItem('loginAccesslist') != null && sessionStorage.getItem('loginAccesslist') != '') {
        var AccessList = (JSON.parse(sessionStorage.getItem('loginAccesslist')))
        var userID = AccessList[0].UserID
        for (var i = 0; i < AccessList.length; i++) {
            if (AccessList[i].ReadAccess == true) {
                finalAccesslist.push(AccessList[i].ModuleID)
            }
            if (AccessList[i].ModuleID == 2) {
                if (AccessList[i].RoleModuleAccessKey == 'Block_Calendar') {
                    sessionStorage.setItem('blockAccess', 1)
                }
                else {
                    sessionStorage.setItem('blockAccess', 0)
                }
            }
        }
    }

    // console.log(guest)
    const history = useNavigate();
    const navigate = useNavigate();

    const [isOpen, setIsOpen] = useState(false)
    const [loginAccesslist, setLoginAccesslist] = useState([])


    const loadScripts = () => {
        // This array contains all the files/CDNs 
        const dynamicScripts = [
            // 'js/jquery.sticky.js',
            // 'js/metisMenu.min.js',
            // 'js/metisMenu-active.js',
            'js/main.js'
        ];

        // for (let i = 0; i < dynamicScripts.length; i++) {
        //     const node = document.createElement('script');
        //     node.src = dynamicScripts[i];
        //     node.type = 'text/javascript';
        //     node.async = false;
        //     document.getElementsByTagName('head')[0].appendChild(node);
        // }
    }
    function logout() {
        sessionStorage.clear()
        navigate('/logout')
    }
    useEffect(() => {
        // loadScripts();
        // jQueryCode()

        // console.log("233", JSON.parse(sessionStorage.getItem('LoginAccesslist'))[0]['IsRead'])
        // setLoginAccesslist(JSON.parse(sessionStorage.getItem('LoginAccesslist')))



    }, []);

    const onRedirect = (path) => {
        history.push({ pathname: path, state: { 'isSearchClear': true } });
    }

    function backtoOrder() {
        // console.log(this.props)
        sessionStorage.removeItem('Is_modify')
        sessionStorage.removeItem('centerID')
        sessionStorage.removeItem('OrderNo')
        sessionStorage.removeItem('OrderID')
        sessionStorage.removeItem('bookArray')
        // sessionStorage.removeItem('validationList')
        sessionStorage.removeItem('navAgain')
        navigate("/orders");
    }

    return (
        <>
            {/* Top menu */}
            <header id="header" class="fixed-top">
                <marquee
                    style={{ fontSize: "16px", color: "#000", fontWeight: "500" }}
                    behavior="scroll"
                    direction="left"
                    scrollamount="5"
                    onMouseOver={(e) => e.target.stop()}
                    onMouseOut={(e) => e.target.start()}
                >
                   <b>Disclaimer and Ownership: </b> All content, including text, graphics, images, and other materials on this website and associated online application systems/accounts, is the exclusive property of India ITME Society or is used under appropriate license. Unauthorized copying, reproduction, distribution, publication, display, modification, creation of derivative works, transmission, or any other form of exploitation of this content is strictly prohibited without prior written consent from the copyright owner. Any violation of these terms will result in immediate legal action and enforcement of intellectual property rights.
                </marquee>
                <div class="container-fluid d-flex align-items-center">

                    {/* <!-- <h1 class="logo mr-auto"><a href="index.html"><span>Com</span>pany</a></h1> --> */}
                    <a class="logo mr-auto"><img src="img/itmeLogoTm-removebg.png" alt="" class="img-fluid" /></a>

                    {guest == true && <nav class="nav-menu d-none d-lg-block">
                        <ul>
                            {/* {finalAccesslist.includes(1) && <Link to={'/dashboard'}>
                                <li className={mod.data.includes(1) ? "nav-item active" : "nav-item"}>
                                    <a className="nav-link py-3">
                                        Dashboard
                                    </a>
                                </li>
                            </Link>} */}
                            {<Link to={'/normalView'}>
                                <li className={mod.data.includes(2) ? "nav-item active" : "nav-item"}>
                                    <a className="nav-link py-3">
                                        Search ITME Center
                                    </a>
                                </li>
                            </Link>}
                            {<Link to={'/calenderView'}>
                                <li className={mod.data.includes(3) ? "nav-item active" : "nav-item"}>
                                    <a className="nav-link py-3">
                                        Calendar View
                                    </a>
                                </li>
                            </Link>}

                            {<Link to={'/login'}>
                                <li className={mod.data == 9 ? "nav-item active" : "nav-item"}>
                                    <a className="nav-link py-3">
                                        Login/Register
                                    </a>
                                </li>
                            </Link>}
                            {/* {userID != '' && userID != null && userID != undefined && <li class="drop-down profile_li pt-1"><a class="profile_class">{initial}</a>
                                <ul>
                                    <li><a>My Profile</a></li>
                                    {<Link style={{ padding: '0' }} to={'/changePassword'}>
                                        <li className="nav-item ">
                                            <a className="nav-link">
                                                Change Password
                                            </a>
                                        </li>
                                    </Link>}
                                    <li onClick={logout} className="nav-item ">
                                        <a className="nav-link">
                                            Logout
                                        </a>
                                    </li>
                                </ul>
                            </li>} */}
                        </ul>
                    </nav>}
                    <nav class="nav-menu d-none d-lg-block">
                        <ul>
                            {finalAccesslist.includes(1) && <Link onClick={() => { mod.data.includes(true) && sessionStorage.removeItem('bookArray') }} to={'/dashboard'}>
                                <li className={mod.data.includes(1) ? "nav-item active" : "nav-item"}>
                                    <a className="nav-link py-3">
                                        Dashboard
                                    </a>
                                </li>
                            </Link>}
                            {finalAccesslist.includes(2) && <Link onClick={() => { mod.data.includes(true) && sessionStorage.removeItem('bookArray') }} to={'/normalView'}>
                                <li className={mod.data.includes(2) ? "nav-item active" : "nav-item"}>
                                    <a className="nav-link py-3">
                                        Search ITME Center
                                    </a>
                                </li>
                            </Link>}
                            {finalAccesslist.includes(3) && <Link onClick={() => { mod.data.includes(true) && sessionStorage.removeItem('bookArray') }} to={'/calenderView'}>
                                <li className={mod.data.includes(3) ? "nav-item active" : "nav-item"}>
                                    <a className="nav-link py-3">
                                        Calendar View
                                    </a>
                                </li>
                            </Link>}
                            {finalAccesslist.includes(4) && <Link onClick={() => { mod.data.includes(true) && sessionStorage.removeItem('bookArray') && sessionStorage.removeItem('Is_modify') }} to={'/my_orders'}>
                                <li className={mod.data.includes(4) ? "nav-item active" : "nav-item"}>
                                    <a className="nav-link py-3">
                                        My Orders
                                    </a>
                                </li>
                            </Link>}
                            {finalAccesslist.includes(23) && <Link onClick={() => { mod.data.includes(true) && sessionStorage.removeItem('bookArray') }} to={'/checkList'}>
                                <li className={mod.data.includes(23) ? "nav-item active" : "nav-item"}>
                                    <a className="nav-link py-3">
                                        CheckList
                                    </a>
                                </li>
                            </Link>}
                            {finalAccesslist.includes(26) && <Link onClick={() => { mod.data.includes(true) && sessionStorage.removeItem('bookArray') }} to={'/thirdPartyOrderList'}>
                                <li className={mod.data.includes(26) ? "nav-item active" : "nav-item"}>
                                    <a className="nav-link py-3">
                                        Client Orders
                                    </a>
                                </li>
                            </Link>}
                            {finalAccesslist.includes(26) && <Link onClick={() => { mod.data.includes(true) && sessionStorage.removeItem('bookArray') }} to={'/guidelines'}>
                                <li className={mod.data.includes(26) ? "nav-item active" : "nav-item"}>
                                    <a className="nav-link py-3">
                                        Vendor Guidelines
                                    </a>
                                </li>
                            </Link>}
                            {finalAccesslist.includes(5) && <Link>
                                <li className={mod.data.includes(5) ? "nav-item drop-down active" : "nav-item drop-down"}>
                                    <a className="nav-link py-3">
                                        Account
                                    </a>
                                    <ul>
                                        {finalAccesslist.includes(18) && <Link onClick={() => { mod.data.includes(true) && sessionStorage.removeItem('bookArray') && sessionStorage.removeItem('Is_modify') }} style={{ padding: '0' }} to={'/orders'}>
                                            <li className={mod.data.includes(5) && mod.data.includes(18) ? "nav-item active p-n3" : "nav-item p-n3"} >
                                                <a className="nav-link">
                                                    Orders
                                                </a>
                                            </li>
                                        </Link>}
                                        {finalAccesslist.includes(27) && <Link onClick={() => { mod.data.includes(true) && sessionStorage.removeItem('bookArray') }} style={{ padding: '0' }} to={'/thirdPartyOrderList'}>
                                            <li className={mod.data.includes(5) && mod.data.includes(27) ? "nav-item active p-n3" : "nav-item p-n3"} >
                                                <a className="nav-link">
                                                    Third Party Orders
                                                </a>
                                            </li>
                                        </Link>}
                                        {finalAccesslist.includes(14) && <Link onClick={() => { mod.data.includes(true) && sessionStorage.removeItem('bookArray') }} style={{ padding: '0' }} to={'/duePaymentsList'}>
                                            <li className={mod.data.includes(5) && mod.data.includes(14) ? "nav-item active p-n3" : "nav-item p-n3"}>
                                                <a className="nav-link">
                                                    Due Payments
                                                </a>
                                            </li>
                                        </Link>}
                                        {finalAccesslist.includes(16) && <Link onClick={() => { mod.data.includes(true) && sessionStorage.removeItem('bookArray') }} style={{ padding: '0' }} to={'/invoicesList'}>
                                            <li className={mod.data.includes(5) && mod.data.includes(16) ? "nav-item active p-n3" : "nav-item p-n3"}>
                                                <a className="nav-link">
                                                    Invoices
                                                </a>
                                            </li>
                                        </Link>}
                                        {finalAccesslist.includes(12) && <Link onClick={() => { mod.data.includes(true) && sessionStorage.removeItem('bookArray') }} style={{ padding: '0' }} to={'/creditNoteList'}>
                                            <li className={mod.data.includes(5) && mod.data.includes(12) ? "nav-item active p-n3" : "nav-item p-n3"}>
                                                <a className="nav-link">
                                                    Credit Note
                                                </a>
                                            </li>
                                        </Link>}
                                        {finalAccesslist.includes(13) && <Link onClick={() => { mod.data.includes(true) && sessionStorage.removeItem('bookArray') }} style={{ padding: '0' }} to={'/debitNoteList'}>
                                            <li className={mod.data.includes(5) && mod.data.includes(13) ? "nav-item active p-n3" : "nav-item p-n3"}>
                                                <a className="nav-link">
                                                    Debit Note
                                                </a>
                                            </li>
                                        </Link>}
                                        {finalAccesslist.includes(19) && <Link onClick={() => { mod.data.includes(true) && sessionStorage.removeItem('bookArray') }} style={{ padding: '0' }} to={'/accountReceiptsList'}>
                                            <li className={mod.data.includes(5) && mod.data.includes(19) ? "nav-item active p-n3" : "nav-item p-n3"}>
                                                <a className="nav-link">
                                                    Receipt
                                                </a>
                                            </li>
                                        </Link>}
                                        {<Link style={{ padding: '0' }} to={'/guidelines'}>
                                            <li className={mod.data.includes(5) && mod.data.includes(19) ? "nav-item active p-n3" : "nav-item p-n3"}>
                                                <a className="nav-link">
                                                    Guidelines & Info
                                                </a>
                                            </li>
                                        </Link>}
                                        {finalAccesslist.includes(32) && <Link onClick={() => { mod.data.includes(true) && sessionStorage.removeItem('bookArray') }} style={{ padding: '0' }} to={'/unblockedCalender'}>
                                            <li className={mod.data.includes(5) && mod.data.includes(32) ? "nav-item active p-n3" : "nav-item p-n3"}>
                                                <a className="nav-link">
                                                    Unblock Calendar
                                                </a>
                                            </li>
                                        </Link>}
                                    </ul>
                                </li>
                            </Link>}
                            {finalAccesslist.includes(6) && <Link>
                                <li className={mod.data == 6 ? "nav-item drop-down active" : "nav-item drop-down"}>
                                    <a className="nav-link py-3">
                                        Security
                                    </a>
                                    <ul>
                                        {finalAccesslist.includes(20) && <Link onClick={() => { mod.data.includes(true) && sessionStorage.removeItem('bookArray') }} style={{ padding: '0' }} to={'/role'}>
                                            <li className={mod.data.includes(6) && mod.data.includes(20) ? "nav-item active p-n3" : "nav-item p-n3"}>
                                                <a className="nav-link">
                                                    Role
                                                </a>
                                            </li>
                                        </Link>}
                                        {finalAccesslist.includes(22) && <Link onClick={() => { mod.data.includes(true) && sessionStorage.removeItem('bookArray') }} style={{ padding: '0' }} to={'/user'}>
                                            <li className={mod.data.includes(6) && mod.data.includes(22) ? "nav-item active p-n3" : "nav-item p-n3"}>
                                                <a className="nav-link">
                                                    User
                                                </a>
                                            </li>
                                        </Link>}
                                    </ul>
                                </li>
                            </Link>}
                            {finalAccesslist.includes(7) && <Link>
                                <li className={mod.data == 7 ? "nav-item drop-down active" : "nav-item drop-down"}>
                                    <a className="nav-link py-3">
                                        Master
                                    </a>
                                    <ul style={{ overflowY: "scroll", height: "15rem", scrollbarWidth: "thin", msOverflowStyle: "none" }}>

                                        {finalAccesslist.includes(15) && <Link onClick={() => { mod.data.includes(true) && sessionStorage.removeItem('bookArray') }} style={{ padding: '0' }} to={'/holidays'}>
                                            <li className={mod.data.includes(7) && mod.data.includes(15) ? "nav-item active p-n3" : "nav-item p-n3"}>
                                                <a className="nav-link">
                                                    Holidays
                                                </a>
                                            </li>
                                        </Link>}
                                        {finalAccesslist.includes(21) && <Link onClick={() => { mod.data.includes(true) && sessionStorage.removeItem('bookArray') }} style={{ padding: '0' }} to={'/events'}>
                                            <li className={mod.data.includes(7) && mod.data.includes(21) ? "nav-item active p-n3" : "nav-item p-n3"} >
                                                <a className="nav-link">
                                                    Type of Event
                                                </a>
                                            </li>
                                        </Link>}
                                        {finalAccesslist.includes(28) && <Link onClick={() => { mod.data.includes(true) && sessionStorage.removeItem('bookArray') }} style={{ padding: '0' }} to={'/timeSlot'}>
                                            <li className={mod.data.includes(7) && mod.data.includes(28) ? "nav-item active p-n3" : "nav-item p-n3"}>
                                                <a className="nav-link">
                                                    Time Slot
                                                </a>
                                            </li>
                                        </Link>}
                                        {finalAccesslist.includes(29) && <Link onClick={() => { mod.data.includes(true) && sessionStorage.removeItem('bookArray') }} style={{ padding: '0' }} to={'/seatingType'}>
                                            <li className={mod.data.includes(7) && mod.data.includes(29) ? "nav-item active p-n3" : "nav-item p-n3"}>
                                                <a className="nav-link">
                                                    Seating Type
                                                </a>
                                            </li>
                                        </Link>}
                                        {finalAccesslist.includes(10) && <Link onClick={() => { mod.data.includes(true) && sessionStorage.removeItem('bookArray') }} style={{ padding: '0' }} to={'/additional_service'}>
                                            <li className={mod.data.includes(7) && mod.data.includes(10) ? "nav-item active p-n3" : "nav-item p-n3"}>
                                                <a className="nav-link">
                                                    Additional Services
                                                </a>
                                            </li>
                                        </Link>}
                                        {finalAccesslist.includes(17) && <Link onClick={() => { mod.data.includes(true) && sessionStorage.removeItem('bookArray') }} style={{ padding: '0' }} to={'/multi_purpose_centre'}>
                                            <li className={mod.data.includes(7) && mod.data.includes(17) ? "nav-item active p-n3" : "nav-item p-n3"}>
                                                <a className="nav-link">
                                                    Multi-Purpose Center’s
                                                </a>
                                            </li>
                                        </Link>}
                                        {finalAccesslist.includes(11) && <Link onClick={() => { mod.data.includes(true) && sessionStorage.removeItem('bookArray') }} style={{ padding: '0' }} to={'/client'}>
                                            <li className={mod.data.includes(7) && mod.data.includes(11) ? "nav-item active p-n3" : "nav-item p-n3"}>
                                                <a className="nav-link">
                                                    Client
                                                </a>
                                            </li>
                                        </Link>}

                                        {finalAccesslist.includes(25) && <Link onClick={() => { mod.data.includes(true) && sessionStorage.removeItem('bookArray') }} style={{ padding: '0' }} to={'/vendor'}>
                                            <li className={mod.data.includes(7) && mod.data.includes(25) ? "nav-item active p-n3" : "nav-item p-n3"}>
                                                <a className="nav-link">
                                                    Vendors
                                                </a>
                                            </li>
                                        </Link>}
                                    </ul>
                                </li>
                            </Link>}
                            {finalAccesslist.includes(8) && <Link onClick={() => { mod.data.includes(true) && sessionStorage.removeItem('bookArray') }} to={'/reportList'}>
                                <li className={mod.data.includes(8) ? "nav-item active" : "nav-item"}>
                                    <a className="nav-link py-3">
                                        Reports
                                    </a>
                                </li>
                            </Link>}
                            {/* {finalAccesslist.includes(24) && <Link
                            >
                                <li class="profile_li nav-item drop-down">
                                    <a href="" class="cartIcon_class " title='Notification'>
                                        <i class="ri-notification-4-line"></i>
                                    </a>
                                    {cartNo != null && <div class="card_badge">{cartNo}</div>}

                                </li>
                            </Link>
                            } */}
                            {/* {finalAccesslist.includes(24) && <Link onClick={() => { mod.data.includes(true) && sessionStorage.removeItem('bookArray') }} to={'/cart'}>
                                <li class="profile_li">
                                    <a href="" class="cartIcon_class" title='Cart'>
                                        <i class="ri-shopping-cart-line"></i>
                                    </a>
                                    {cartNo != null && <div class="card_badge">{cartNo}</div>}

                                </li>
                            </Link>
                            } */}
                            {userID != '' && userID != null && userID != undefined && <li class="drop-down profile_li pt-1"><a style={{ cursor: 'pointer' }} class="profile_class">{initial}</a>
                                <ul style={{ paddingTop: '0px' }}>
                                    <li class="name_li">
                                        <a >
                                            <p class="nameClass">{name}</p>
                                            <p class="company_name">{companyName != null && companyName}</p>
                                        </a>
                                    </li>
                                    {<Link onClick={() => { mod.data.includes(true) && sessionStorage.removeItem('bookArray') }} style={{ padding: '0' }} to={'/profile'}>
                                        <li className="nav-item ">
                                            <a className="nav-link">
                                                My Profile
                                            </a>
                                        </li>
                                    </Link>}
                                    {<Link onClick={() => { mod.data.includes(true) && sessionStorage.removeItem('bookArray') }} style={{ padding: '0' }} to={'/changePassword'}>
                                        <li className="nav-item ">
                                            <a className="nav-link">
                                                Change Password
                                            </a>
                                        </li>
                                    </Link>}
                                    <li onClick={logout} className="nav-item ">
                                        <a style={{ cursor: 'pointer' }} className="nav-link">
                                            Logout
                                        </a>
                                    </li>
                                </ul>
                            </li>}

                        </ul>
                    </nav>

                    {/* <!-- <div class="header-social-links">
        <a href="#" class="twitter"><i class="icofont-twitter"></i></a>
        <a href="#" class="facebook"><i class="icofont-facebook"></i></a>
        <a href="#" class="instagram"><i class="icofont-instagram"></i></a>
        <a href="#" class="linkedin"><i class="icofont-linkedin"></i></i></a>
      </div> --> */}

                </div>
            </header >
            {
                JSON.parse(sessionStorage.getItem('Is_modify')) == true &&
                <>
                    <div class="orange_strip" style={{
                        marginTop: '115px',
                        padding: '11px 15px',
                        background: '#ff8f00',
                        lineHeight: '1',
                        color: '#fff',
                        fontWeight: '600',
                        textAlign: 'center',
                        marginBottom: '-85px',
                        position: 'relative',
                    }}
                    >You are in process of modifying your order <span style={{ fontSize: '14px' }}>
                            {(sessionStorage.getItem('OrderNo'))}
                        </span>. <span class="back_to_MyOrder_btn" onClick={backtoOrder}
                        ><i class="fa fa-arrow-left"></i> Back to My Order</span></div>
                </>
            }
            {/* <div className="navg">
                <ul className="nav nav-pills">
                    <Link to={'/exhibitor_dashboard'}>
                        <li className="nav-item ">
                            {" "}
                            <a className="nav-link  active px-4 py-2">
                                Dashboard{" "}
                            </a>{" "}
                        </li>
                    </Link>
                    {JSON.parse(sessionStorage.getItem('ApplicationDataSS'))['Flag'] != null &&
                        (JSON.parse(sessionStorage.getItem('ApplicationDataSS'))['Flag'])
                        &&
                        <Link to={'/manualForms'}>
                            <li className="nav-item ">
                                {" "}
                                <a className="nav-link  px-4 py-2">
                                    Exhibitor Manual Forms
                                </a>{" "}
                            </li>
                        </Link>
                    }
                    <Link to={'/rulesRegulations'}>
                        <li className="nav-item ">
                            {" "}
                            <a className="nav-link  px-4 py-2">
                                Rules and Regulations
                            </a>{" "}
                        </li>
                    </Link>
                    <Link to={'/importantDates'}>
                        <li className="nav-item ">
                            {" "}
                            <a className="nav-link  px-4 py-2" >
                                Important Dates
                            </a>{" "}
                        </li>
                    </Link>
                    <Link to={'/spacebooking'}>
                        <li className="nav-item ">
                            {" "}
                            <a className="nav-link  px-4 py-2" >
                                Spacebooking
                            </a>{" "}
                        </li>
                    </Link>

                    <li className="nav-item dropdown ">
                        {" "}
                        <a
                            className="nav-link dropdown-toggle px-4 py-2"
                            data-bs-toggle="dropdown"
                            href="javascript:void(0)"
                            role="button"
                            aria-haspopup="true"
                            aria-expanded="false"
                        >
                            Accounts
                        </a>
                        <div className="dropdown-menu">
                            {" "}   <Link to={'/updatePayment'}>

            N                    <a className="dropdown-item" href="update-payment.html">
                                    Update Payment
                                </a>   </Link>
                        </div>
                    </li>
                </ul>
                <span className="log-1" onClick={e => toggleModal()}>
                    <i className="fa fa-power-off" aria-hidden="true" /> Logout
                </span>
            </div> */}

            {/* Top menu */}

        </>
    );
}
export default Header;